import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import EntryWrapper from '../../../components/EntryWrapper';
import Search from '../../../components/Search';
import PopularServices from '../../../components/PopularServices';
import SellersGallery from '../../../components/SellersGallery';
import TrustedBy from '../../../components/TrustedBy';
import Testimonials from '../../../components/Testimonials';

const LoggedOutHomepageClient: React.FC = () => {
  useImpressionManager();

  return (
    <EntryWrapper isV16={true}>
      <Search isV16={true} />
      <PopularServices isV16={true} />
      <SellersGallery isV16={true} />
      <Testimonials isV16={true} />
      <TrustedBy isV16={true} />
    </EntryWrapper>
  );
};

export default LoggedOutHomepageClient;
